import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b22ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tagDiv" }


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  bgColor: {
    required: true,
    type: String,
    default: "#f85f16",
  },
  textColor: {
    required: true,
    type: String,
    default: "#ffe5d5",
  },
},
  setup(__props) {

const props = __props;


//---------------------传入参数、回调、监听定义---------------------
//定义传入变量



// let frameSize = ref<string>('28px');
//定义监听事件
// watch(
//   () => props.size,
//   (newVal: any) => {
//     //变更执行事件
//     frameSize.value = newVal + 'px'
//   }
// );

//定义回调事件
//const emit = defineEmits<{
//  (e: "resultTag", test: string): void;
//}>();

//定义生命周期事件
//onMounted(() => {
//  //生命周期处理内容
//});


// ---------------------数据变量定义-------------------------

//变量定义
//let test: any = ref<string>();



// ---------------------方法定义-------------------------

//const testMethon = function (item:string): string {
//  return "";
//};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})